<template>
  <ModalPanel :open="runners !== null" @close="emit('cancel')">
    <DialogTitle as="h3" class="text-base font-semibold text-gray-900 dark:text-white">
      Recreate runners?
    </DialogTitle>
    <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
      {{ message }} Jobs running on them are interrupted. Unknown runners are not recreated and keep
      the previous settings until you edit or recreate them.
    </p>
    <ul
      class="mt-3 list-disc pl-5 text-sm text-gray-700 dark:text-gray-300"
      data-testid="recreate-runners"
    >
      <li v-for="runner in runners ?? []" :key="runner.runnerId">
        {{ runner.name
        }}<span v-if="runner.recreate === false" class="text-gray-500 dark:text-gray-400">
          (unknown, not recreated automatically)</span
        >
      </li>
    </ul>
    <div class="mt-5 gap-3 sm:mt-4 sm:flex sm:flex-row-reverse">
      <button
        type="button"
        class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-red-500 disabled:opacity-50 sm:w-auto dark:bg-red-500 dark:hover:bg-red-400"
        :disabled="busy"
        data-testid="confirm-recreate"
        @click="emit('confirm')"
      >
        {{ busy ? 'Saving…' : confirmLabel }}
      </button>
      <button
        type="button"
        class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto dark:bg-white/10 dark:text-white dark:inset-ring-white/5 dark:hover:bg-white/20"
        :disabled="busy"
        @click="emit('cancel')"
      >
        Cancel
      </button>
    </div>
  </ModalPanel>
</template>

<script setup lang="ts">
import { DialogTitle } from '@headlessui/vue';
import ModalPanel from '@/components/ModalPanel.vue';
import type { RunnerCacheUsage } from '@/api/caches';

defineProps<{
  /** null closes the dialog. */
  runners: RunnerCacheUsage[] | null;
  message: string;
  confirmLabel: string;
  busy?: boolean;
}>();

const emit = defineEmits<{ (e: 'confirm'): void; (e: 'cancel'): void }>();
</script>
